<template>
  <header class="flex-shrink-0 relative h-16 bg-white flex items-center">
    <div class="absolute inset-y-0 left-0 md:static md:flex-shrink-0">
      <router-link
        to="/"
        class="flex items-center justify-center h-16 w-16 text-xl bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-600 md:w-20 text-white"
      >
        ATM
      </router-link>
    </div>

    <div class="absolute inset-y-0 right-0 pr-4 flex items-center sm:pr-6 md:hidden">
      <button
        type="button"
        class="-mr-2 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-600"
        @click="mobileMenuOpen = true"
      >
        <span class="sr-only">Open main menu</span>
        <MenuIcon class="block h-6 w-6" aria-hidden="true" />
      </button>
    </div>

    <UserBox />
  </header>
  <Transition>
    <UserBoxMobile v-if="mobileMenuOpen" @close="mobileMenuOpen = false" />
  </Transition>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import { MenuIcon } from '@heroicons/vue/outline'
import UserBox from '../UserBox/index.vue'
import UserBoxMobile from '../UserBox/mobile.vue'

export default defineComponent({
  name: 'Header',
  components: {
    MenuIcon,
    UserBox,
    UserBoxMobile,
  },
  setup() {
    const mobileMenuOpen = ref(false)

    return {
      mobileMenuOpen,
    }
  },
})
</script>
